import { Delete } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Zoom,
} from "@mui/material";
import { useState } from "react";
import { connect, useDispatch } from "react-redux";
import { getSingleMachine } from "../actions/machines";
import { getNotification } from "../actions/notification";
import { deleteGenericAttachment } from "../actions/objects";
import { useNavigate } from "react-router";
import { withCurrentAccountPrefix } from "../utils/accountMode";
export default connect(({}) => ({}), {
  getSingleMachine,
  deleteGenericAttachment,
  getNotification,
})((props) => {
  const [openDialogDelete, setopenDialogDelete] = useState(props.open);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const handleDelete = (nodeid) => {
    let rootNID = props.rootNodeId;

    localStorage.setItem("delNodeidClass", "dl-" + nodeid?.split("247fn://247uptime.io/")[1])


    if( props.from === "maintenance_task_template")
    {
      props.deleteCallback(props.nodeid);
      props.close(false);
      return;
    }

    props.deleteGenericAttachment({ nodeid });

    props.close(false);
    setTimeout(function() {
      if (props.from === "notification") {
        dispatch({ type: "CLEARNOTIFICATION", payload: {} });
        props.getNotification(
          { nodeid: rootNID ? rootNID : props.nodeid },
          "GETSINGLENOTIFICATION"
        );
      } else {

       
        dispatch({ type: "CLEARMACHINE", payload: {} });
        props.getSingleMachine(rootNID ? rootNID : props.nodeid);

        if (props.from === "machine" || props.from === "maintenance_task_template")  {
          localStorage.setItem("delNodeidClass"," dl-"+props.nodeid.split("247fn://247uptime.io/")[1])
          props.deleteCallback(props.nodeid)
        } else {
          if (props?.from === "faq") {
            navigate(
              withCurrentAccountPrefix(
                "/machine-overview?nodeid=" +
                encodeURIComponent(rootNID) +
                "&tab=3"
              )
            );
          } else {
            navigate(
              withCurrentAccountPrefix(
                "/machine-overview?nodeid=" +
                encodeURIComponent(rootNID) +
                "&tab=4"
              )
            );
          }
        }
      }
    }, 2000);
  };
  const handleClose = () => {
    props.close(false);
  };

  return (
    <Dialog
      open={openDialogDelete}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{ backdropFilter: "blur(4px)" }}
      TransitionComponent={Zoom}
    >
      <DialogTitle id="alert-dialog-title">{"Bestätigung löschen"}</DialogTitle>
      <DialogContent id="alert-dialog-description">
        Bist du sicher, das du das löschen möchtest ?
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Nein</Button>
        <Button onClick={() => handleDelete(props.nodeid)}>
          <Delete />
          Ya
        </Button>
      </DialogActions>
    </Dialog>
  );
});
